module.exports = __webpack_public_path__ + "static/media/wallDrawing1112.f3c16196.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingPageContent/images/wallDrawing1112.png
// module id = 414
// module chunks = 0